<template>
    <!-- #region use with /card page -->
    <template v-if="$route.path == '/card'">
        <div class="w-full lg:w-360px bg-white mb-4 py-4 px-6 rounded-10 flex flex-col">
            <div class="mb-2 flex items-center">
                <img class="ml-0 mr-2 my-auto" v-if="creditCard.brand == 'Visa'" src="@/assets/icon/ic-visa.svg" />
                <img class="ml-0 mr-2 my-auto" v-if="creditCard.brand == 'MasterCard'" src="@/assets/icon/ic-mastercard.svg" />
                <img class="ml-0 mr-2 my-auto" v-if="creditCard.brand == 'JCB'" src="@/assets/icon/ic-jcb.svg" />
                <div class="text-a-brown-502314 text-14 lg:text-16 ml-0 mr-auto my-auto tracking-2px">**** **** **** {{creditCard.lastDigits}}</div>
            </div>
            <div class="ml-11 mb-6 text-14 lg:text-16 text-a-brown-9f8273">{{creditCard.name}}</div>
            <div class="flex items-center">
                <img class="ml-0 my-auto w-5 h-5 cursor-pointer" v-show="creditCard.isSelect" @click="setDefaultCard()" src="@/assets/icon/ic-checkbox-brown.svg" />
                <div class="ml-0 my-auto w-5 h-5 rounded-5 border border-a-brown-d7c7b8 bg-white cursor-pointer" @click="setDefaultCard()" v-show="!creditCard.isSelect"></div>
                <div class="ml-2 my-auto text-14 lg:text-16 text-a-brown-502314">{{lbl.creditCard.default_card}}</div>
                <button class="flex ml-6" @click="onDeleteCard()">
                    <img class="ml-0 my-auto"  src="@/assets/icon/ic-bin-red.svg" />
                    <div class="ml-2 my-auto text-14 lg:text-16 text-a-red-d62300">{{lbl.creditCard.delete_card}}</div>
                </button>
            </div>
        </div>
    </template>
    <!-- #end region use with /card page -->

    <div v-else class="flex pb-3">
        <img class="ml-0 mr-2 my-auto w-5 h-5 cursor-pointer" v-show="creditCard.isSelect" @click="onSelectCreditCard()" src="@/assets/icon/ic-checkbox-red.svg" />
        <div class="ml-0 mr-2 my-auto w-5 h-5 rounded-5 border border-a-brown-d7c7b8 bg-white cursor-pointer" @click="onSelectCreditCard()" v-show="!creditCard.isSelect"></div>
        <img class="ml-0 mr-2 my-auto" v-if="creditCard.brand == 'Visa'" src="@/assets/icon/ic-visa.svg" />
        <img class="ml-0 mr-2 my-auto" v-if="creditCard.brand == 'MasterCard'" src="@/assets/icon/ic-mastercard.svg" />
        <img class="ml-0 mr-2 my-auto" v-if="creditCard.brand == 'JCB'" src="@/assets/icon/ic-jcb.svg" />
        <div class="text-14 lg:text-16 ml-0 mr-auto my-auto tracking-2px">**** **** **** {{creditCard.lastDigits}}</div>
    </div>
</template>

<script>
// mixins
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "CreditCardItem",
    emits:['onDeleteCard', 'onSelectCreditCard', 'setDefaultCard'],
    mixins: [LocaleMixin],
    props: {
        creditCard: Object,
    },
    created: function() {
        if (this.$route.name == 'SubscriptPayment' || this.$route.name == 'OrderPayment') {
            if (this.creditCard.isDefault) {
                this.onSelectCreditCard();
            }
        }
    },
    methods: {
        onDeleteCard: function(){
            this.$emit('onDeleteCard', this.creditCard);
        },
        onSelectCreditCard: function() {
            this.$emit('onSelectCreditCard', this.creditCard);
        },
        setDefaultCard: function(){
            this.$emit('setDefaultCard', this.creditCard);
        },
    },
}
</script>

<style>

</style>
